import type { ReactNode } from 'react';
import { site } from '../site';

interface Props {
    href: string;
    children: ReactNode;
    className?: string;
}

/** Link to another site; rendered as plain text on white-label variants without external links. */
export function ExternalLink({ href, children, className }: Props) {
    if (!site.externalLinks) return <span className={className}>{children}</span>;
    return (
        <a href={href} className={className}>
            {children}
        </a>
    );
}
